const recordLabel = (info, instance) => {
    if (!info.scripts.hasOwnProperty("toString")) {
        return `Unknown ${info.label}`;
    }
    const label = info.scripts.toString(instance);
    return label == null ? "NULL" : label;
};

export default recordLabel;



// WEBPACK FOOTER //
// ./app/data/selectors/recordLabel.js